"use strict";
var moment = require('moment');
var DAYS_IN_WEEK = 7;
var WEEKEND_DAY_NUMBERS = [0, 6];
var getDaySpan = function (event, offset, startOfWeek) {
    var span = 1;
    if (event.end) {
        var begin = moment(event.start).isBefore(startOfWeek) ? startOfWeek : moment(event.start);
        span = moment(event.end)
            .endOf('day')
            .add(1, 'minute')
            .diff(begin.startOf('day'), 'days');
        if (span > DAYS_IN_WEEK) {
            span = DAYS_IN_WEEK;
        }
    }
    var totalLength = offset + span;
    if (totalLength > DAYS_IN_WEEK) {
        span -= (totalLength - DAYS_IN_WEEK);
    }
    return span;
};
exports.getDayOffset = function (event, startOfWeek) {
    var offset = 0;
    if (moment(event.start).startOf('day').isAfter(moment(startOfWeek))) {
        offset = moment(event.start).startOf('day').diff(startOfWeek, 'days');
    }
    return offset;
};
var isEventIsPeriod = function (_a) {
    var event = _a.event, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
    var eventStart = moment(event.start);
    var eventEnd = moment(event.end || event.start);
    if (eventStart.isAfter(periodStart) && eventStart.isBefore(periodEnd)) {
        return true;
    }
    if (eventEnd.isAfter(periodStart) && eventEnd.isBefore(periodEnd)) {
        return true;
    }
    if (eventStart.isBefore(periodStart) && eventEnd.isAfter(periodEnd)) {
        return true;
    }
    if (eventStart.isSame(periodStart) || eventStart.isSame(periodEnd)) {
        return true;
    }
    if (eventEnd.isSame(periodStart) || eventEnd.isSame(periodEnd)) {
        return true;
    }
    return false;
};
var getEventsInPeriod = function (_a) {
    var events = _a.events, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
    return events.filter(function (event) { return isEventIsPeriod({ event: event, periodStart: periodStart, periodEnd: periodEnd }); });
};
var getWeekDay = function (_a) {
    var date = _a.date;
    var today = moment().startOf('day');
    return {
        date: date,
        isPast: date.isBefore(today),
        isToday: date.isSame(today),
        isFuture: date.isAfter(today),
        isWeekend: WEEKEND_DAY_NUMBERS.indexOf(date.day()) > -1
    };
};
exports.getWeekViewHeader = function (_a) {
    var viewDate = _a.viewDate;
    var start = moment(viewDate).startOf('week');
    var days = [];
    for (var i = 0; i < DAYS_IN_WEEK; i++) {
        var date = start.clone().add(i, 'days');
        days.push(getWeekDay({ date: date }));
    }
    return days;
};
exports.getWeekView = function (_a) {
    var events = _a.events, viewDate = _a.viewDate;
    var startOfWeek = moment(viewDate).startOf('week');
    var endOfWeek = moment(viewDate).endOf('week');
    var eventsMapped = getEventsInPeriod({ events: events, periodStart: startOfWeek, periodEnd: endOfWeek }).map(function (event) {
        var offset = exports.getDayOffset(event, startOfWeek);
        var span = getDaySpan(event, offset, startOfWeek);
        return {
            event: event,
            offset: offset,
            span: span,
            extendsLeft: moment(event.start).isBefore(startOfWeek),
            extendsRight: moment(event.end).isAfter(endOfWeek)
        };
    }).sort(function (itemA, itemB) {
        var startSecondsDiff = moment(itemA.event.start).diff(moment(itemB.event.start));
        if (startSecondsDiff === 0) {
            var endA = moment(itemA.event.end || itemA.event.start);
            var endB = moment(itemB.event.end || itemB.event.start);
            return moment(endB).diff(endA);
        }
        return startSecondsDiff;
    });
    var eventRows = [];
    var allocatedEvents = [];
    eventsMapped.forEach(function (event, index) {
        if (allocatedEvents.indexOf(event) === -1) {
            allocatedEvents.push(event);
            var rowSpan_1 = event.span + event.offset;
            var otherRowEvents = eventsMapped.slice(index + 1).filter(function (nextEvent) {
                if (allocatedEvents.indexOf(nextEvent) === -1 &&
                    nextEvent.offset >= rowSpan_1 &&
                    rowSpan_1 + nextEvent.span <= DAYS_IN_WEEK) {
                    nextEvent.offset -= rowSpan_1;
                    rowSpan_1 += nextEvent.span + nextEvent.offset;
                    allocatedEvents.push(nextEvent);
                    return true;
                }
            });
            eventRows.push({
                row: [
                    event
                ].concat(otherRowEvents)
            });
        }
    });
    return eventRows;
};
exports.getMonthView = function (_a) {
    var events = _a.events, viewDate = _a.viewDate;
    var start = moment(viewDate).startOf('month').startOf('week');
    var end = moment(viewDate).endOf('month').endOf('week');
    var eventsInMonth = getEventsInPeriod({
        events: events,
        periodStart: moment(viewDate).startOf('month'),
        periodEnd: moment(viewDate).endOf('month')
    });
    var days = [];
    for (var i = 0; i < end.diff(start, 'days') + 1; i++) {
        var date = start.clone().add(i, 'days');
        var day = getWeekDay({ date: date });
        day.inMonth = date.clone().startOf('month').isSame(moment(viewDate).startOf('month'));
        if (day.inMonth) {
            day.events = getEventsInPeriod({
                events: eventsInMonth,
                periodStart: moment(date).startOf('day'),
                periodEnd: moment(date).endOf('day')
            });
        }
        else {
            day.events = [];
        }
        days.push(day);
    }
    var rows = Math.floor(days.length / 7);
    var rowOffsets = [];
    for (var i = 0; i < rows; i++) {
        rowOffsets.push(i * 7);
    }
    return {
        rowOffsets: rowOffsets,
        days: days
    };
};
//# sourceMappingURL=calendarUtils.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/calendar-utils/dist/src/calendarUtils.js
 ** module id = 3
 ** module chunks = 0
 **/